import React from 'react';
import { Info } from 'lucide-react';

type StatCardProps = {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  color?: 'green' | 'red' | 'blue' | 'orange' | 'purple';
  helperText?: string;
};

export default function StatCard({ label, value, icon, color = 'blue', helperText }: StatCardProps) {
  const bgColor = {
    green: 'bg-green-50 text-green-600',
    red: 'bg-red-50 text-red-600',
    blue: 'bg-blue-50 text-blue-600',
    orange: 'bg-orange-50 text-orange-600',
    purple: 'bg-purple-50 text-purple-600',
  };

  const [showHelper, setShowHelper] = React.useState(false);

  return (
    <div className="bg-white rounded-lg shadow p-6 border border-gray-100">
      <div className="flex justify-between items-start">
        <div className="relative">
          <div className="flex items-center gap-2">
            <div className="text-sm text-gray-600 font-medium">{label}</div>
            {helperText && (
              <div className="relative">
                <button
                  type="button"
                  aria-label={helperText}
                  className="w-6 h-6 inline-flex items-center justify-center rounded-full border border-gray-200 text-gray-600 hover:bg-gray-100"
                  onClick={() => setShowHelper((prev) => !prev)}
                  onMouseEnter={() => setShowHelper(true)}
                  onMouseLeave={() => setShowHelper(false)}
                >
                  <Info className="w-3.5 h-3.5" />
                </button>
                {showHelper && (
                  <div className="absolute z-20 mt-2 w-64 max-w-xs rounded-md border border-gray-200 bg-white shadow-lg text-xs text-gray-700 p-3 transform left-1/2 -translate-x-1/2 md:left-auto md:right-0 md:translate-x-0">
                    {helperText}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={`text-2xl font-bold mt-2 ${bgColor[color]}`}>{value}</div>
        </div>
        {icon && <div className="text-2xl w-10 h-10 flex items-center justify-center rounded-full bg-gray-50">{icon}</div>}
      </div>
    </div>
  );
}
